import { createEntityComboBox } from './helpers/createEntityComboBox';

import { createQueryHook } from '~/shared/providers/api';
import { QueryHookResult } from '~/shared/providers/api/createQueryHook';

export type SelectableMaterial = QueryHookResult<
  typeof useMaterialsQuery
>[number];

export const useMaterialsQuery = createQueryHook(
  'shared.selectMaterial',
  (params: { ids?: string[]; searchTerm?: string }) => ({
    items: {
      __args: {
        filter: {
          ids: params.ids,
          searchTerm: params.searchTerm,
        },
        pagination: {
          limit: 50,
          offset: 0,
        },
      },
      entries: {
        id: true,
        name: true,
        skuNumber: true,
        effectivePricingUnit: true,
        measurementUnit: true,
        itemGroup: {
          name: true,
        },
      },
    },
  }),
  {
    select: (data) => data?.items.entries ?? [],
  },
);

type EntityProps = {
  id: string;
  name: string;
  skuNumber: string;
  itemGroup?: {
    name?: string;
  } | null;
};

const formatOptionLabelText = (entity: EntityProps) => {
  const sku = entity.skuNumber?.replace(/_/g, ' ') ?? '';
  const relevantSkuNumber = sku.length > 20 ? undefined : sku;
  const numericPart = relevantSkuNumber?.match(/\d+/)?.[0];

  return `${numericPart ? `#${numericPart} - ` : ''}${entity.name}`;
};

export const SelectMaterial = createEntityComboBox.remotelySearched(
  'SelectMaterial',
  useMaterialsQuery,
  {
    formatLabel: (entity) => `${formatOptionLabelText(entity)}`,
    formatSubLabel: (entity) => entity.itemGroup?.name ?? '',
    compactSelection: true,
  },
);
